module.exports = __webpack_public_path__ + "static/media/availability-slide-4.dbeb584f.jpg";